import { all, fork } from 'redux-saga/effects';
import address from 'src/store/address/saga';
import chat from 'src/store/chatmedicalmanage/saga';
import config from 'src/store/config/saga';
import coupon from 'src/store/coupon/saga';
import department from 'src/store/department/saga';
import dictionary from 'src/store/dictionary/saga';
import doctor from 'src/store/doctor/saga';
import ims from 'src/store/im/saga';
import inquriy from 'src/store/inquiry/saga';
import order from 'src/store/order/saga';
import patients from 'src/store/patients/saga';
import prescription from 'src/store/prescription/saga';
import { policy } from 'src/store/right/reducer';
import service from 'src/store/service/saga';
import sugarblood from 'src/store/sugarblood/saga';
import video from 'src/store/video/saga';
import { channel } from './store/channel/reducer';
import familyDoctor from './store/familydoctor/saga';
import massageTherapy from './store/massageTherapy/saga';
import medicine from './store/medicine/saga';
import specialists from './store/specialist/saga';
import physical from 'subPackages/szPhysical/store/physical/saga';

export default function* rootSaga() {
  yield all([
    fork(doctor),
    fork(patients),
    fork(sugarblood),
    fork(department),
    fork(inquriy),
    fork(coupon),
    fork(address),
    fork(order),
    fork(prescription),
    fork(dictionary),
    fork(config),
    fork(video),
    fork(chat),
    fork(service),
    fork(policy),
    fork(channel),
    fork(ims),
    fork(specialists),
    fork(massageTherapy),
    fork(familyDoctor),
    fork(medicine),
    fork(physical),
  ]);
}
